import Dexie from "dexie";

export const db = new Dexie("contractDB");

db.version(1).stores({
	contracts: "token, contract_id, data, lastUpdated",
});

export const getStoredContract = async (token) => {
	return await db.contracts.get(token);
};

export const storeContract = async (token, contractData) => {
	await db.contracts.put({
		token,
		contract_id: contractData.contract_id,
		data: contractData,
		lastUpdated: new Date().getTime(),
	});
};
